module.exports = __webpack_public_path__ + "img/cbn.509c47b7.png";